import About1 from "../../images/browse-jobs/about-1.png"
import About2 from "../../images/browse-jobs/about-2.png"
import Benefit1 from "../../images/browse-jobs/Group-1089.png"
import Benefit2 from "../../images/browse-jobs/Group-1090.png"
import Benefit3 from "../../images/browse-jobs/Group-1091.png"
import Benefit4 from "../../images/browse-jobs/Group-1092.png"
import Feature1 from "../../images/Group_1296.png";
import Feature2 from "../../images/Group_1301.png";
import Feature3 from "../../images/Group_1302.png";
import Feature4 from "../../images/Group_1303.png";
import TalentsAPI from "./TalentsAPI"
import reviewWritingImg from "../../images/review-writing.png";


class BrowseJobsAPI {
    static jobs = {
        "copy-paste-jobs": {
            "name": "Copy Paste Jobs",
            "to": "/browse-jobs/copy-paste-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Copy Pasting is one of the easiest online jobs that involves posting classified ads. It can help you earn extra income. It doesn't need you to spend long continuous hours in front of your computer. If you can spare a few hours, you are good to go.",
            "importances": [
                "Ads play a major role by creating a positive impression on the viewers. It takes just a few seconds for a person to decide if they will continue in your webpage or will divert away, so the right kind of ads besides the right landing page will help in preventing high bounce rates in websites of any organization.",
                "Persons who are experienced in Copy Pasting help you to promote your business services and products. You can hire them for any niche such as real estate, electronics, pet care, automotive, and others to easily reach out to the masses with less expenses.",
                "People doing this job often manually post the ads on different classified websites which have a high ranking in the search engine based on the location of their target audience. This results in a good exposure of the brand, its products, or services to the people, which results in an increase in sales. The product awareness significantly increases with it."
            ],
            "duties": {
                "description": "",
                "data": ["In these jobs, you need to copy a certain ad content, search for “free classifieds” in Google. Then the free classified website has to be opened where you can post them by clicking the “post free ad” button. The copied content needs to be pasted into the classified website to post the ads. Then you just need to copy the web address where the ads have been successfully posted. The payment for this will be made on the number of such posted ads."]
            },
            "howItWorks": {
                "description": "You generally have to open an account and use software to make your Copy Pasting work easier. The ads created need to be posted on websites so that the visitors can see them and get tempted to click them for knowing more. It gets more visitors to the website.",
                "details": [
                    {
                        "detail": "Scroll through the available Copy Paste Jobs and choose the one on which you would like to work."
                    },
                    {
                        "detail": "Fill up the application form online."
                    },
                    {
                        "detail": "Your application will be evaluated through various phases before shortlisting."
                    },
                    {
                        "detail": "Once you are shortlisted for the job, you will need to start working on it and do the needful in the set deadline."
                    },
                    {
                        "detail": "Submit your work to receive the payment that has been agreed upon while accepting the job."
                    }
                ]
            },
            "eligibility": {
                "title": "Qualifications needed for a virtual assistant",
                "eligibilities": [
                    "A PC or laptop.",
                    "A fairly good writing ability.",
                    "Knowledge of the internet and computer."
                ]
            },
            "profession": "person for Copy Pasting job",
            "skillsNeeded": {
                "title": "",
                "skills": []
            },
            "benefits": [
                {
                    "name": "Easy way to earn by spending a few hours doing the job.",
                    "img": Benefit1
                },
                {
                    "name": "Flexibility to take work as per your availability.",
                    "img": Benefit2
                },
                {
                    "name": "With enough experience, you can set a price for the work and negotiate with clients when needed.",
                    "img": Benefit3
                },
                {
                    "name": "Consistently good performance can help you sustain a long term relationship with clients and hence get your more jobs easily.",
                    "img": Benefit4
                }
            ],
            "checks": [
                "Check his past performance by going through the reviews provided by clients. One with genuinely good reviews is generally trustworthy.",
                "Ask him for his experience which will assure you regarding the positive outcome with his professional and high-quality ad design.",
                "It is better if he provides you with a complete proof report for tracking their ad submission.",
                "He should provide you with the source file at the end with an HD image. If the person is providing you with more design and size variations, that's even better.",
                "Should be able to stick to your delivery. Basically, he should have a quick turnaround time.",
                "Should be responsive and available to answer your queries in less time.",
                "Besides Copy Pasting, if you need posts on social media platforms also, check his proficiency in the same because most people are available actively on Instagram and Twitter, and hence these form an easy way of reaching out to many people",
                "Explain all your requirements and see if he can provide you with customized designs along with the type of colors you want in the banners or ads to fulfill your requirements.",
                "His work should be unique and free from any plagiarism when you need ads for promoting your brand or startup."
            ],
            "expected": [
                "They can ensure quick and reliable live ads.",
                "Better outcomes assure 100% satisfaction.",
                "Quick growth of the business by the expansion of customer base.",
                "Better generation of profit through enhanced sales with less investment.",
                "Web traffic increases with a higher number of sign-ups.",
                "Introducing new products in the same brand becomes easy owing to the established market presence."
            ],
            "faqs": []
        },
        "proof-reading-jobs": {
            "name": "Proof Reading Jobs",
            "to": "/browse-jobs/proof-reading-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Every content needs to undergo a review process, which is termed 'proofreading\". The word has two parts, \"proof\" and \"read\" which means making a content error-proof. This ensures that the intended audience gets the right message from whatever is being conveyed to them. The job involves carefully going through the content and marking the errors. In other words, you need to go through the content with a completely new perspective.",
            "importances": [],
            "duties": {
                "description": "",
                "data": []
            },
            "howItWorks": {
                "description": "",
                "details": [
                    {
                        "detail": "Go through all the available proofreading jobs and select the one which you think can be easily completed by you."
                    },
                    {
                        "detail": "Check the deadline and requirements of the job to make sure you can do it."
                    },
                    {
                        "detail": "Fill the online application for the job and send it."
                    },
                    {
                        "detail": "Your application will be screened through various stages before getting shortlisted."
                    },
                    {
                        "detail": "Once shortlisted, you will be assigned the job. Complete and submit it to get the payment."
                    }
                ]
            },
            "eligibility": {
                "title": "Qualifications needed for a virtual assistant",
                "eligibilities": [
                    "You should have a bachelor's degree in Journalism or English. This is the basic criteria but doesn't mean that graduates in other streams cant work as a proofreader.",
                    "You should have a good understanding of the written language.",
                    "In case the client asks to do a test task for demonstration of your skills, you should be willing to take it.",
                    "If you have received a task for some particular industry such as law, then a law degree is quite useful. So based on your background, you can pick up the proofreading job.",
                    "You must be able to work independently and meet the deadlines.",
                    "Attention to detail is one of the key requirements of the job.",
                    "A knowledge of using various latest digital software such as word processing, spreadsheets, and editing software is extremely helpful.",
                    "Knowledge of various editorial styles is an added advantage."
                ]
            },
            "profession": "proofreader",
            "skillsNeeded": {
                "title": "",
                "skills": []
            },
            "benefits": [
                {
                    "name": "Your skills of punctuating and smoothing the flow of thoughts presented in content get polished.",
                    "img": Benefit1
                },
                {
                    "name": "A chance to learn while earning. Since it needs perfection in grammar, your grammar skills also improve while you do the jobs.",
                    "img": Benefit2
                },
                {
                    "name": "You can set your rates for a specific article length and negotiate with the clients when needed.",
                    "img": Benefit3
                },
                {
                    "name": "Flexibility to take up projects as per your availability. Thus, you can work independently.",
                    "img": Benefit4
                }
            ],
            "checks": [],
            "expected": [],
            "faqs": [
                {
                    "id": 1,
                    "question": "What parameters need to be checked while hiring someone for a proofreading job?",
                    "answer": "For a better outcome, here are the parameters you need to check while hiring someone for a proofreading job:<br/><br/> 1. Less turnaround time.<br/> 2. Attention to details.<br/> 3. Experience in doing a similar job in the past.<br/> 4. Reviews from the clients about his work quality and sincerity in task completion."
                },
                {
                    "id": 2,
                    "question": "What are the most important things to be taken care of while proofreading?",
                    "answer": "Spelling, grammar, punctuation, and capitalization are the primary things to be taken care of in proofreading."
                },
                {
                    "id": 3,
                    "question": "Do proofreaders have high demand?",
                    "answer": "Yes, there is always a high demand for proofreaders with good experience and a successful track record in accomplishing similar jobs in the past."
                },
                {
                    "id": 4,
                    "question": "How are the changes made in a document tracked in proofreading?",
                    "answer": "Generally, the proofreaders using MS word will use the \"Track Changes\" option so that you can know whatever changes have been made in the document."
                },
                {
                    "id": 5,
                    "question": "What does proofreading involve?",
                    "answer": "Proofreading is done after the writing process to ensure that everything that is written is correct. It involves checking for spelling mistakes, grammar, punctuation, wrong use of words, any repetition of words, spacing, formatting, typographical and issues. Once the revision and editing of the content are done, you can proofread it."
                },
                {
                    "id": 6,
                    "question": "What are the basic qualifications needed to become a proofreader?",
                    "answer": "You need to have attention to detail, and knowledge of the basic English language, with good written and verbal communication skills. to become a proofreader"
                },
                {
                    "id": 7,
                    "question": "Can a person become a proofreader without a degree?",
                    "answer": "A proofreading job doesn't need any diploma or certification in proofreading. So, yes, without a degree also a person can work as a proofreader."
                },
                {
                    "id": 8,
                    "question": "How to check to proofread?",
                    "answer": "You need to see if there are sentence fragments or run-on sentences and make sure to use the correct form of the verb which agrees with the subject. The pronouns also need to be used correctly without getting confused. And finally, check for the right punctuation to see if the sentence looks meaningful."
                },
                {
                    "id": 9,
                    "question": "What are some good proofreading strategies?",
                    "answer": "Some strategies for proofreading are:<br/><br/> 1. Review the whole document in stages.<br/> 2. Read it aloud to identify the errors.<br/> 3. The headings need to be reviewed separately and changes must be made as needed."
                },
                {
                    "id": 10,
                    "question": "What are the common symbols used for proofreading?",
                    "answer": "Some symbols used in proofreading are for:<br/><br/> 1. New paragraph<br/> 2. Delete something.<br/> 3. Close up space<br/> 4. Transposing the elements.<br/> 5. Inserting something in the line.<br/> 6. Inserting en dash or em dash.<br/> 7. Moving to the left or right.<br/> 8. Making italics<br/> 9. Changing to capital letter<br/> 10. Vertical alignment and horizontal alignment."
                },
                {
                    "id": 11,
                    "question": "Is it good to establish a career in proofreading?",
                    "answer": "Yes, proofreading is one of the most demanded online jobs that you can do from the comfort of your home. All you need to have is a laptop, desktop with good internet connectivity and strong knowledge of the English language to perfectly make a piece of content error-free. Since content is in high demand in every organization, so is proofreading because it makes the content flawless by removing all errors."
                }
            ]
        },
        "online-survey-jobs": {
            "name": "Survey Jobs",
            "to": "/browse-jobs/online-survey-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Online surveys involve market research where you need to complete an online survey and get paid for it. People often sign up for these for having an extra income. It is quite interesting and pretty much everyone can do it easily as there are no such specific qualifications needed.",
            "importances": [
                "Online survey jobs intend to easily reach the target audience and engage them in the least duration. Also, for the companies, the market research is done easily at less cost but the outcome is great in real-time. The chances of error in knowing the response from the user reduces as they provide their input directly into the system with no human intervention.",
                "Also, since online surveys are short and quick, there are more people willing to take them, with respect to the written questions or attending telephonic interviews. They are even free to skip a question in case they find a question inappropriate."
            ],
            "duties": {
                "description": "",
                "data": [
                    "He should be able to gather a large pool of participants depending on the requirement of the project to have people from various niches, sectors, regions, or nations.",
                    "Pre scanning tools should be used by him for demographic targeting based on age, gender nationality, educational qualification, finance, hobbies, health, and shopping habits.",
                    "Using screeners to create a niche of the participant pool.",
                    "In-depth market research to get insights into the current consumer demands and trends in the market."
                ]
            },
            "howItWorks": {
                "description": "The online survey often involves a structured questionnaire that a certain target audience needs to fill out. The format and the length of the questionnaires generally vary. You can earn well through online survey jobs by signing up to some companies and use your free time to do the jobs",
                "details": [
                    {
                        "detail": "Click on the online survey jobs you want to do and fill up the online application form for the same."
                    },
                    {
                        "detail": "The application will be screened in multiple steps before it gets shortlisted."
                    },
                    {
                        "detail": "You will be provided a short training as well as all details on how to complete the jobs before actually starting the work."
                    },
                    {
                        "detail": "Follow the instructions and once the job is done, you will be paid."
                    }
                ]
            },
            "eligibility": {
                "title": "This job doesn't need some specific eligibility criteria to be fulfilled. But some basic requirements have to be met if you intend to do the online survey jobs.",
                "eligibilities": [
                    "Having a PC or laptop and knowing how to use it.",
                    "A good internet connection.",
                    "English writing/ communication skills."
                ]
            },
            "profession": "surveyor",
            "skillsNeeded": {
                "title": "",
                "skills": [
                    "Open-ended questions",
                    "Multiple-choice questions",
                    "Basic logic questions"
                ]
            },
            "benefits": [
                {
                    "name": "Flexible working hours as per your availability.",
                    "img": Benefit1
                },
                {
                    "name": "Earning while working from home.",
                    "img": Benefit2
                },
                {
                    "name": "It is a good part-time opportunity for students, working professionals as well as housewives.",
                    "img": Benefit3
                }
            ],
            "checks": [],
            "expected": [
                "Attention to the requirements of the clients.",
                "Capability of market research.",
                "Quick turnaround time, at least to meet the deadline without fail.",
                "Provide high-quality data for deep and accurate insights.",
                "Should be responsive to answer client's queries at any time"
            ],
            "faqs": [
                {
                    "id": 1,
                    "question": "Why is an online surveying job important?",
                    "answer": "For an organization, small business, or startup, online surveyors help in understanding why the consumers use a product or service or dislike it if any. They check with the right target audience to help the firms make the informed decisions."
                },
                {
                    "id": 2,
                    "question": "How important is maintaining data quality in an online survey?",
                    "answer": "This is extremely important because the outcomes form the basis for decisions that can make or break an organization. So every online surveyor must verify and monitor the participants thoroughly to get reliable data without compromising the quality."
                },
                {
                    "id": 3,
                    "question": "Who can do online survey jobs?",
                    "answer": "Anyone interested in market research and want a part-time job besides their primary job, like a freelancer can do it."
                },
                {
                    "id": 4,
                    "question": "What limitations do online survey has?",
                    "answer": "There are 2 methodological limitations of online surveys. One is that it is difficult to describe the population to which they are distributed. The second is that the respondents may have biased opinions. The research can be valuable when the findings deduced from a certain sample can be generalized for a certain population."
                },
                {
                    "id": 5,
                    "question": "It is safe to do online survey jobs?",
                    "answer": "Yes, it is safe if you are doing it with genuine freelancing or a similar website. There are fraudsters also who won't pay you after the job is done so better to be safe while applying for such jobs. Make sure that you apply for it only on reputed platforms."
                },
                {
                    "id": 6,
                    "question": "What is the general pay for online survey work?",
                    "answer": "On average the amount earned per hour with the online survey is $1-2 but it varies with the type of survey needed."
                },
                {
                    "id": 7,
                    "question": "Are there paid survey sites in India which are legitimate?",
                    "answer": "Yes. Some of these include Toluna.com, ValuedOpinions, iPanelOnline, Swagbucks, Cashcrate, TellyPulse(StarPanel), The Panel Station, OpinionBureau, and others."
                },
                {
                    "id": 8,
                    "question": "How long do paid surveys take? Do they actually benefit organizations?",
                    "answer": "It takes just 5-15 minutes to complete the paid surveys. Yes, they benefit organizations by providing important insights about the consumers."
                },
                {
                    "id": 9,
                    "question": "What is required for an online survey job?",
                    "answer": "For an online survey job, a person needs to have a laptop or PC with good internet connectivity. He must have a registered Gmail address to get notifications for survey work. And finally, a payment processor like PayPal must be there to receive the payment from the client after the work is done."
                }
            ]
        },
        "content-writing-jobs": {
            name: "Content Writing Jobs",
            to: "/browse-jobs/content-writing-jobs",
            about: 'Content writing jobs are one of the highly demanded jobs today. It is important because every organization needs the right content to build trust in the potential customers, generate leads, and earn loyal consumers that help their business flourish in the long run. May it be technology, travel, food, fashion, or anything else, a firm needs content to thrive.',
            aboutImages: [
                About1,
                About2,
            ],
            skillsNeeded: {
                title: 'Popular types of content writers who are hired for content writing jobs',
                skills: ['Bloggers', 'Brand journalist', 'Copywriter', 'Ghostwriter', 'Technical writer', 'Social media writer', 'Email writer', 'Scriptwriter']
            },
            benefits: [{
                name: 'Earn by working from home. For the content writing jobs, you will get to learn while earning as you need to research on the topics which will also enhance your research skills',
                img: Benefit1
            },
            {
                name: 'It is a great opportunity for the housewives and others who want a part-time income.',
                img: Benefit2
            },
            {
                name: 'Association with us on our reliable platform to strengthen your career on something you are good at.',
                img: Benefit3
            }, {
                name: 'You can take up jobs as per your availability so there will be no workload unless you are free to take up some.',
                img: Benefit4
            },
            {
                name: 'Our site lets you fix your price for the work you will be doing. For example, you can fix the sample pricing for each piece of content that you will be delivering, to 100 INR.',
                img: Benefit2
            }
            ],
            importances: [
                'Whether it is small organizations, startups, or larger businesses, everyone needs the right kind of content to flourish. It is because the content is used for creating awareness about the brand and its products or services. So, in a market with cutthroat competition, it is extremely important to deliver the audience the right kind of content they are looking for so as to add value to the time invested by them.',
                'Content creators are needed everywhere by the government as well as private bodies like the real estate sector, educational sector, marketing, finance, and legal sectors too. Based on your requirement, you can hire writers having specialization in the respective niche.'
            ],
            potential: '',
            duties: [],
            howItWorks: {
                description: '',
                details: [{
                    title: 'Check the available jobs',
                    detail: 'As described above, there are various types of content writing jobs which you can check on our website and choose the option which best suits your skillset.'
                },
                {
                    title: 'Begin the process of application',
                    detail: 'After selecting a job, you need to send your job application online. This application will be screened through a multi-level review system before being screened for recruitment.'
                },
                {
                    title: 'Get payment after completing the job',
                    detail: 'Once you are hired, there will be a short training session which you need to attend. Then you are good to start. You will be getting paid via Paypal or other payment modes once the job is completed successfully.'
                }
                ]
            },
            eligibility: {
                title: 'Here are a few things needed for you to be eligible for any of the part-time jobs on our website',
                eligibilities: [
                    'A PC/laptop with Windows or Mac is required for completing the work which you will be assigned to after being hired.',
                    'Make sure that you have a good internet connection as the work needs to be done online and submitted. High-speed broadband connectivity is better.',
                    'We need to investigate your background, so you should be ready to sign a release that will allow us to do that. This is for addressing the security requirements of our clients. You need to sign a release only when we will connect with you directly.'
                ]
            },
            profession: 'content writer',
            checks: [
                'A professional having a good track record with positive client reviews.',
                'Able to strictly follow the guidelines and customize the content as per the requirement',
                'Should adhere strictly to deadlines to avoid unnecessary delays.',
                'The writer must provide unique, plagiarism free content.',
                'Should be creative enough to spark curiosity among the readers, when needed.',
                'The writer should be friendly with SEO and must be able to customize pages.',
                'Make sure that the writer is responsive so he can quickly reply to your queries and efficiently meet your requirements.'
            ],
            expected: [],
            faqs: [
                {
                    "id": 1,
                    "question": "What is the most important aspect you need to look in a content writer?",
                    "answer": "The writer should be able to create plagiarism free content in the provided deadline."
                },
                {
                    "id": 2,
                    "question": "Why is it important for writers to abide by SEO rules?",
                    "answer": "This is important especially for web content because the keywords used in the content helps in ranking of the webpage. There are inbound and outbound links also used for the same. Google search engine identifies the SEO friendly web pages and ranks them higher than others."
                },
                {
                    "id": 3,
                    "question": "Why are ghostwriters needed?",
                    "answer": "These are the category of content creators who write a piece of article or e-book or similar piece of content which is later published under the name of someone else. In short, they do not get the credit for the content created by them. Often people who need to create e-books, book reviews hire ghost writers."
                },
                {
                    "id": 4,
                    "question": "Is it important for a writer to know using WordPress?",
                    "answer": "This is an added advantage when a content writer knows using WordPRess and other tools such as Elementor, WP bakery, Divi builder and others for page customization."
                },
                {
                    "id": 5,
                    "question": "It is mandatory for a content writer to ensure an error free content?",
                    "answer": "Yes, the writer can make use of tools like Grammarly and must proof read the article to check if it has the correct logical flow for better efficiency. He must make all efforts to produce error free content."
                },
                {
                    "id": 6,
                    "question": "What are some tools that every content writer must use?",
                    "answer": "Hemmingway editor, Grammarly, Copyscape, are some of the basic tools that should be used for creating unique and error free content having better readability."
                },
                {
                    "id": 7,
                    "question": "Are there some basic rates for content creators?",
                    "answer": "No, the rates charged by the content writers completely depend on their skill set, expertise in a niche and the years of experience. Knowledge of tools like WordPress and others is an added advantage. <br/><br/>Also, based on the requirements of the clients, they fix the prices. Hence there are no standardized rates for content writers."
                },
                {
                    "id": 8,
                    "question": "Why web content has to be plagiarism free?",
                    "answer": "This is extremely important because high quality content is always unique and the search engine rank sites with such content higher"
                }
            ]
        },
        "graphics-design": {
            name: "Graphics Design Jobs",
            to: "/browse-jobs/graphics-design",
            about: 'Graphic designers make use of computer software or make designs by hand for the creation of visual concepts for communicating their ideas for informing others, inspiring them, or attracting consumers. They generally make the overall design for ads, corporate reports, magazines, and brochures.',
            aboutImages: [
                About1,
                About2,
            ],
            skillsNeeded: {
                title: 'Skills needed for graphic designers',
                skills: ['Analytical skills', 'Artistic skills.', 'Creativity', 'Communication skills', 'Computer skills', 'Time Management']
            },
            benefits: [{
                name: 'You get a chance to learn while earning.',
                img: Benefit1
            },
            {
                name: 'It will enhance your experience with the clients.',
                img: Benefit2
            },
            {
                name: 'You can set your working hours as per your availability.',
                img: Benefit3
            }
                , {
                name: 'Experienced candidates can set their base price for the jobs.',
                img: Benefit4
            }
            ],
            importances: ['Graphic designers have a vital role in marketing a product or brand and making it liked by more people. They are often needed to work in association with the marketing team, ad and promotions team, and public relations for enhancing the overall outcome.',
                'There are various fields in which graphic designers may specialize. So, there are landscape architects, industrial designers, interior designers, and artists for creating interactive designs in retail spaces, museum exhibitions and public art exhibits.'],
            duties: {
                description: 'Graphic designers have the amazing potential to combine art and technology to bring on artistic impacts. they make use of color, text and images to make complex data more accessible to the audience.',
                data: [
                    'Creation of original image, logos, illustrations that can deliver the intended message to the target customers.',
                    'Determining the scope of a project by meeting with the art directors or clients.',
                    'Willingness to incorporate the changes as and when requested by the clients. Also, they should review the signs to ensure they are error-free prior to printing and publishing.',
                    'Creation of designs through the use of layout software, photo editing software, and digital illustration.'
                ]
            },
            howItWorks: {
                description: 'Graphic designers have the amazing potential to combine art and technology to bring on artistic impacts. they make use of color, text and images to make complex data more accessible to the audience.',
                details: [
                    {
                        detail: 'Choose the graphic designing job that matches your skills and experience from the list of available jobs.'
                    },
                    {
                        detail: 'Your application will be screened through multiple stages before the final selection.'
                    },
                    {
                        detail: 'Your application will be screened through multiple stages before the final selection.'
                    },
                    {
                        detail: 'Once you are selected for the job, understand all the instructions and try to stick to the given deadline to create a good impression on the client.'
                    }
                ]
            },
            eligibility: {
                title: 'Graphic designers have the amazing potential to combine art and technology to bring on artistic impacts. ',
                eligibilities: [
                    'If you want to work as a graphic designer, you should have a bachelor\'s degree in graphic design or an equivalent field. There are colleges where students can opt for courses in web design along with computerized design, printing techniques, commercial graphics production, studio art, principles of design. Besides this, courses in writing, business, and marketing is an add-on for such jobs.',
                    'Complete certifications or other latest courses to update yourself',
                    'Those who completed internships or have good experience have better chances to bag good job opportunities',
                    'Software product vendors provide certifications, licenses, and registrations for graphic designers. If you have these, it shows a competence level and gives you a competitive advantage over others.'
                ]
            },
            profession: 'graphic designer',
            checks: [
                'Experience in graphic designing.',
                'Reviews from previous clients to know how reliable he is.',
                'Ability to stick to deadlines.',
                'Delivering professional-level work as requested.',
                'Expertise in Photoshop or other editing or illustrator tools.',
                'Responsive to your queries or ideas so they can be promptly imbibed as needed.'
            ],
            expected: [
                'Infographics',
                'Edit an image and trace it',
                'Design t-shirts',
                'Create PDF documents, banners, and brochures',
                'Design events flyers, web banners, or social media banners for a business.',
                'Photo Retouching.',
                'Removal of a background',
                'Creation of professional Logo',
                'Design a Business card or Thank you card',
                'Editing a PDF document',
                'Making an animation video.'
            ],
            faqs: [
                {
                    "id": 1,
                    "question": "Why are graphic designers needed?",
                    "answer": "Small and large scale businesses rely on graphic designers to grow by making the service or product offerings more appealing to potential customers. This is how the consumer base grows easily as people easily get attracted to something that looks good."
                },
                {
                    "id": 2,
                    "question": "Is it difficult to learn graphic design?",
                    "answer": "Beginners will find this somewhat challenging but as soon as you understand the basic knowledge and skills, you can put them into practice and gain experience, which will make it an easy job for you."
                },
                {
                    "id": 3,
                    "question": "What qualifications do graphic designers have?",
                    "answer": "Generally, graphic designers have a foundation degree or degree in graphic designing or some other art and subject that is design-based. <br/><br/>It is important to have a working knowledge of the software tools used for graphic designing such as InDesign, QuarkXPress, Photoshop, Illustrator."
                },
                {
                    "id": 4,
                    "question": "How long does it take to be a graphic designer?",
                    "answer": "You need at least 4 years of graphic designing by completing the bachelor's degree program in graphic arts. Here you will be taught core topics in graphic designing besides general education. You will also have to choose from among various electives."
                },
                {
                    "id": 5,
                    "question": "Is a graphic designing career very stressful?",
                    "answer": "Designers who try to combine their passion with their work might find it somewhat stressful as the vision of your clients will direct your artwork. It will have deadlines and your work will also be subjected to consistent criticisms, which are the stress involved in the job."
                },
                {
                    "id": 6,
                    "question": "How important is it to gain a certification in graphic designing?",
                    "answer": "This plays an important role as it not only adds to your skills but gives you a competitive edge over others. Entry-level graphic designers must complete certifications to swiftly move ahead in their career path."
                }
            ]
        },
        "video-animation-jobs": {
            name: "Video & Animation Jobs",
            to: "/browse-jobs/video-animation-jobs",
            about: 'The animation we see in the commercials, TV shows, movies, and video games are created by the animators. The candidates in the video and animation sectors generally specialize in a specific area like background designing, characters, or just the scenery and make use of computer software for accomplishing their work. The collaborative efforts of the members in a video and animation team result in an outcome that the viewers enjoy.',
            aboutImages: [
                About1,
                About2,
            ],
            duties: {
                data: [
                    "Creation of expressive character animation showing a range of emotions.",
                    "Brainstorming of ideas and their conceptualization to producing concept sketches.",
                    "Collaboration with clients, animators, and producers.",
                    "Integration of 3 D components into final products of commercial quality.",
                    "Creation of high-quality animations by the use of hand key animation and motion capture data.",
                    "Comprehension and execution of direction from the lead animator."
                ]
            },
            skillsNeeded: {
                title: 'Popular types of content writers who are hired for content writing jobs',
                skills: ['Bloggers', 'Brand journalist', 'Copywriter', 'Ghostwriter', 'Technical writer', 'Social media writer', 'Email writer', 'Scriptwriter']
            },
            benefits: [{
                name: 'By working from home, you get the flexibility to choose projects based on your availability.',
                img: Benefit1
            },
            {
                name: 'These jobs let you work for a variety of clients and enhance your efficiency by learning new skills and gaining more experience that can be mentioned in your resume.',
                img: Benefit2
            },
            {
                name: 'When you reach a certain point with enough experience, you can fix your own price for the projects you are undertaking and hence get paid higher than other freelancers.',
                img: Benefit3
            }
            ],
            importances: [
            ],
            potential: '',
            howItWorks: {
                description: '',
                details: [{
                    detail: 'There is a list of video and animation jobs on our website. You need to check those which suit your skills.'
                },
                {
                    detail: 'Send your online application for a specific job. It would take about 24 hours for getting screened through a multi-stage evaluation process.'
                },
                {
                    detail: 'Once you are shortlisted, check out all the requirements and instructions before starting the assignment. Complete and submit it to receive the payment for the job.'
                }
                ]
            },
            eligibility: {
                eligibilities: [
                    'A college degree is generally not needed for an animator but if they have a degree then it gives them a competitive advantage. Some degrees that hirers look for are bachelor\'s degrees in fine arts, computer graphics, or equivalent discipline. Those intending to create animation for video games need a degree in interactive media.',
                    'This includes classes in animation. filming and drawing from any degree school. Along with this, skills in graphics and animation can be improved through consistent practice and remaining updated by learning the new skills. Internships are also a great way of adding a feather to your resume and grabbing the attention of hirers for amazing opportunities.<br/><br/>Other soft skills that candidates need to have for the work from home video and animation jobs are communication skills, creativity, and time management.'
                ]
            },
            profession: 'animator',
            checks: [
                "Quick turnaround time.",
                "Experience in doing works similar to the one you are going to assign.",
                "Responsive.",
                "Proficiency in using video and animation tools.",
                "Open to make revisions as per client's requirement.",
                "Ready for a test job before being hired.",
                "Check reviews from previous clients to know his performance delivery."
            ],
            expected: [
                "Creation of explainer videos",
                "Scriptwriting",
                "Voiceover with the accent you require",
                "Custom Branding",
                "Addition of subtitles",
                "Editing",
                "Full HD (1080p) animation",
                "Music",
                "Addition of watermark or logo along with contact details"
            ],
            faqs: [
                {
                    "id": 1,
                    "question": "Is a career in video and animation stable and reliable?",
                    "answer": "Yes, it is a stable career option. When you are employed for this work with some company, you can have a stable income with other added benefits."
                },
                {
                    "id": 2,
                    "question": "Is it difficult to get a job in animation?",
                    "answer": "Yes because of high competition. The job opportunities are better for those getting referrals from people already in the industry and also for those who have a good skillset with a lot of experience."
                },
                {
                    "id": 3,
                    "question": "What qualifications are needed to become an animator?",
                    "answer": "You need a higher national diploma or degree in the relevant subjects to become an animator in film, photography, illustration, 3 D design, or others. It is also better if you have a postgraduate qualification."
                },
                {
                    "id": 4,
                    "question": "What challenges do animators face?",
                    "answer": "They might have to work for long hours when working for a company and it can be as high as 50 hours per week to meet deadlines."
                },
                {
                    "id": 5,
                    "question": "Can video and animation jobs be done from home?",
                    "answer": "Yes, you can work in these as a freelancer at your convenience. It is safe only when you are applying to reputed companies or on reputed freelancing platforms. This will ensure safety by safeguarding your payment from the clients. Thus you don't have to worry as you will be paid for all the efforts you are putting."
                }
            ]
        },
        "online-tutoring-jobs": {
            "name": "Tutoring Jobs",
            "to": "/browse-jobs/online-tutoring-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "The global pandemic resulted in lockdowns everywhere. Along with offices, the schools were also shut down. This resulted in a spike in the demand for online tutoring jobs as it was the safest way teachers could impart knowledge to the students. This job is considered to be one of the most reputed jobs where you can use your time for the well being of the youth and help them in creating a bright future.",
            "importances": [],
            "duties": {
                "description": "",
                "data": [
                    "A free demo class for every subject that is being taught.",
                    "Meeting with the parents of the student after an exam to discuss his progress to ensure that parents are fully aware of their kids' performance.",
                    "Special classes for students having lower scores to focus on their weaker areas in a much better way.",
                    "Conducting practice sessions at the end of every chapter without quickly moving to the next topic just for the sake of completing the syllabus.",
                    "Conducting a class to teach the students about the rules in an online class and how to use the system and online portals to gain maximum benefit from them.",
                    "Mock tests at regular intervals along with surprise tests to know the level of preparation of the students. This will ensure that the students take the classes seriously. It will make them seriously complete everything that is taught in the class, without pushing them to study at a later date."
                ]
            },
            "howItWorks": {
                "description": "",
                "details": []
            },
            "eligibility": {
                "title": "",
                "eligibilities": [
                    "Comprehensive subject knowledge to be able to confidently deliver lectures to the students.",
                    "There is no special degree course for becoming a tutor but you can opt for advanced programs in the subjects that you intend to teach.",
                    "Working experience in teaching is a huge advantage.",
                    "Patience in learning the latest technologies for delivering classes online and clarifying the doubts from students as and when needed.",
                    "A PC or desktop with a good internet connection."
                ]
            },
            "profession": "online tutor",
            "skillsNeeded": {
                "title": "",
                "skills": []
            },
            "benefits": [
                {
                    "name": "You will learn about new ways of teaching when opting for this profession.",
                    "img": Benefit1
                },
                {
                    "name": "Flexible working hours, i.e you can take up jobs based on your availability.",
                    "img": Benefit2
                },
                {
                    "name": "Earn while teaching from the safety and comfort of your home.",
                    "img": Benefit3
                },
                {
                    "name": "Gain experience which will help you get well-paid teaching jobs in the future.",
                    "img": Benefit4
                }
            ],
            "checks": [
                "Teaching experience of the teacher.",
                "Reviews from students who had previously enrolled and the ranks that they secured in the exam.",
                "The number of teaching hours per week and subjects covered by the teacher.",
                "Doubt clearing sessions and practice sessions to ensure that students have clear fundamentals."
            ],
            "expected": [],
            "faqs": [
                {
                    "id": 1,
                    "question": "What are the steps of becoming an online tutor?",
                    "answer": "First, you need to set up a free online tutoring profile. Based on your experience, you will be getting requests where you can introduce yourself to the students and start delivering classes."
                },
                {
                    "id": 2,
                    "question": "Is a college degree mandatory to do an online tutoring job?",
                    "answer": "No, you don't necessarily need higher educational degrees to do online tutoring. With normal graduation also you can teach students of the school from class 1-10 depending on your proficiency in a subject."
                },
                {
                    "id": 3,
                    "question": "How often do online tutors get paid?",
                    "answer": "This varies from person to person. Some online tutors charge weekly and some monthly."
                },
                {
                    "id": 4,
                    "question": "What are the basic requirements to start online tutoring?",
                    "answer": "You need to have the strong subject knowledge to decide which subject you will be teaching to the students. Apart from these basic computer skills, a laptop or PC with a good internet connection is mandatory for online tutoring."
                },
                {
                    "id": 5,
                    "question": "Can a person without any experience become an online tutor?",
                    "answer": "Yes, there are certain platforms where a person can become an online tutor even without experience. Some of these include Qkids, Preply, Savvy, Tandem, Udemy, Verbling, Italki, and Lingoda."
                },
                {
                    "id": 6,
                    "question": "Is classroom teaching better or online tutoring?",
                    "answer": "In these times of pandemic online tutoring is best as it prevents the chances of spreading of Covid-19. Apart from this, it is always a better idea as a lot of time that is wasted in commutation is saved and students can use it for learning a lot of things."
                },
                {
                    "id": 7,
                    "question": "What are some characteristics of a good online tutor?",
                    "answer": "A good online tutor must have a strong command of the subject that he is going to teach. He must be enthusiastic, persistent, confident, adaptable, and compassionate"
                },
                {
                    "id": 8,
                    "question": "Is online tutoring also for teachers who have been teaching in classrooms since always?",
                    "answer": "Yes, but they need to learn some basic computer skills to get started. It will be difficult in the beginning but gradually they will find it more convenient compared to regular classroom teaching."
                }
            ]
        },
        "translation-jobs": {
            "name": "Translation Jobs",
            "to": "/browse-jobs/translation-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Translation jobs involve the conversion of information from one language to another so that the end-user can understand everything that is written. In India, there are many languages and also the globalization of the economy has resulted in companies working with many multinationals. This necessitates the role of translators who can convey everything exactly in a language that the other party can understand easily.",
            "importances": [],
            "duties": {
                "description": "",
                "data": []
            },
            "howItWorks": {
                "description": "",
                "details": [
                    {
                        "detail": "First you need to check what all translation jobs are available on the platform."
                    },
                    {
                        "detail": "Based on the languages you are proficient in, click the job that you can complete easily."
                    },
                    {
                        "detail": "Start the application process and submit it online."
                    },
                    {
                        "detail": "It will be subjected to a multi-stage review process before the final selection."
                    },
                    {
                        "detail": "Once selected, there will be a short training session to ensure that you are well prepared for the job."
                    },
                    {
                        "detail": "Stick to the deadline, and submit your work to receive the payment through any of the payment modes such as PayPal, bank transfer, or others."
                    }
                ]
            },
            "eligibility": {
                "title": "",
                "eligibilities": [
                    "Diploma or a degree in the specific language from a recognized university/institution after completing 10+2. Some colleges take students on the basis of entrance tests. This is mainly needed when you want to pursue BA, MA, and M. Phil in a specific language.<br/><br/>Popular languages that you can pick up for taking entrance tests include Test of Evaluation of French which is a French proficiency test organized by Alliance Françoise. Other similar tests include TCF, TEF, DELF, and DALF.<br/><br/>For the German language, Max Mueller Bhawan and Bhartiya Vidya Bhawan organize classes for teaching the language.",
                    "You do not need a combination of specific subjects in 10+2 to become a translator but your language skills should be strong enough to pursue a career in this.",
                    "Generally, 3 courses are available for translators, certification, degree, or diploma. You must have completed 10+2 if you want to opt for the certification or degree.<br/><br/>Make sure to complete a certification in the desired language if you want to opt for the diploma course.",
                    "You should be able to accurately convert the given text to the desired language quickly in the given duration."
                ]
            },
            "profession": "translator",
            "skillsNeeded": {
                "title": "",
                "skills": [
                    "fluently read the given document",
                    "write and edit copies",
                    "write summaries",
                    "Attention to detail",
                    "sticking to deadlines",
                    "impeccable knowledge of grammar and spelling"
                ]
            },
            "benefits": [
                {
                    "name": "Learn while working from home.",
                    "img": Benefit1
                },
                {
                    "name": "A chance to work in diverse niches that will make you more proficient in translation jobs.",
                    "img": Benefit2
                },
                {
                    "name": "Get paid as per the latest market standards.",
                    "img": Benefit3
                },
                {
                    "name": "A chance to learn new things while working.",
                    "img": Benefit4
                }
            ],
            "checks": [
                "Proficiency in translating the particular language you are looking for.",
                "Check if he is a certified translator.",
                "Reviews from previous clients to know about the person's performance.",
                "A high level of accuracy while translating.",
                "Quick turnaround time."
            ],
            "expected": [],
            "faqs": [
                {
                    "id": 1,
                    "question": "Is it safe to opt for online translation jobs?",
                    "answer": "Yes, people are increasingly opting for online translation jobs to work from the comfort of their homes. Based on your qualifications and experience, they will hire you. But you have to make sure that you are applying to reputed companies to avoid falling into prey to scams."
                },
                {
                    "id": 2,
                    "question": "Can a person make his living by doing translation work?",
                    "answer": "If you are skillful and has a lot of experience in translating, then earning a decent amount every month becomes very easy for you, and hence you can make it your source of living but for beginners and intermediate level translators, it is better to do it as a part time job only.<br/><br/>If we see the example of translators in the US, they have an average salary of $19.67/hour but people even more than this based on their expertise level. Those who have been certified by the American Translators Association can earn over 66 usd/hr."
                },
                {
                    "id": 3,
                    "question": "What qualifications do hiring companies look out for in a translator?",
                    "answer": "A candidate willing to work as a translator needs to have a degree or should have completed post graduation in translation. Degrees in different languages where translation work is in high demand, also works but this just gives the candidate a competitive edge and is not mandatory. People having combined degrees in law or science along with certain languages also apply for such jobs.",
                },
                {
                    "id": 4,
                    "question": "How essential is language proficiency for translation jobs?",
                    "answer": "Language proficiency is mandatory to become a translator. A person must have the perfect knowledge of at least 2 languages to be able to translate. Of this one should be English.",
                },
                {
                    "id": 5,
                    "question": "What are the pre requisites of applying to a translation job?",
                    "answer": "For applying to translation jobs, make sure to choose a language and study it thoroughly and extensively. Then join some training course to complete the specialized training and get certification in the same too.<br/><br/>You need to polish your computer skills too besides learning more about the industry where you wish to apply for the translation jobs. Then after you get your first job, you will gradually gain experience.",
                },
                {
                    "id": 6,
                    "question": "How to flourish as a translator?",
                    "answer": "In order to flourish as a translator, you need to learn more languages. Though the start might not be impressive but with gradual experience, you can flourish easily in the career."
                },
                {
                    "id": 7,
                    "question": "Which foreign language gets highly paid in India?",
                    "answer": "French, German and Spanish are the most popular languages for translating jobs in India. Entry level candidates get 4-6 lakhs per annum for French and German and for Spanish language they get 3-5 lakhs per annum."
                },
                {
                    "id": 8,
                    "question": "How do I get a translator certificate in India?",
                    "answer": "Candidates wishing to start their career in translation need to opt for certification course, diploma or degree course in the specific language after completing 12th. There are different universities in India offering such courses.<br/><br/>In foreign countries, candidates willing for such jobs get ATA certified by ensuring that the language they are learning is supported by ATA."
                },
                {
                    "id": 9,
                    "question": "Can a person become a translator even if he doesn't have a degree?",
                    "answer": "Having a degree is just an added advantage. If you know the language, doing some training or certification course is enough as long as you can proficiently do the translation work."
                }
            ]
        },
        "typing-jobs": {
            "name": "Online Typing Jobs",
            "to": "/browse-jobs/typing-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Keyboards and smartphones have become a vital part of our lives irrespective of the jobs we do. So, everyone has more than average typing skills and it is not just anymore about the translators, transcriptionists, or secretaries. Gradually the typing skills of people are improving which makes them suitable for work from home typing jobs and earn a handsome amount.",
            "importances": [],
            "duties": {
                "description": "",
                "data": [
                    "Typists or Word Processors",
                    "Web Designer/Developer: These are mainly for IT people who can type at least 45 wpm. Efficient skills in the field can boost pay as well as help candidates reach their goals easily.",
                    "Transcriptionist",
                    "Legal Transcribers",
                    "Chat Agents: This is a support job where numerous customers have to be served every day. The workload is usually high with not so attractive payment. Many larger companies are replacing the chat agents with artificial chatbots.",
                    "Data Entry Specialists",
                    "Virtual Assistant",
                    "They can have a range of office works such as email communication, editing, data entry.",
                    "Closed Captioning and Subtitling Typing Jobs",
                    "Court Reporter",
                    "Journalist/Writer",
                    "Secretary/Personal Assistant",
                    "Translator: Typing is an essential requirement in these jobs even when artificial intelligence plays an important role."
                ]
            },
            "howItWorks": {
                "description": "",
                "details": [
                    {
                        "detail": "Our website has a number of typing jobs from which you need to select one."
                    },
                    {
                        "detail": "Apply for the job online."
                    },
                    {
                        "detail": "There will be a multi-stage screening process through which your application will undergo."
                    },
                    {
                        "detail": "Once selected for the job, you need to check the instructions clearly and submit them within the deadline to get paid."
                    }
                ]
            },
            "eligibility": {
                "title": "",
                "eligibilities": [
                    "Fast typing skills, 10-finger key skills.",
                    "A laptop or desktop.",
                    "Good internet connectivity.",
                    "Few free hours to spare for the job.",
                    "good communication, writing and spelling skills to avoid errors.",
                    "Some core subject skills to bag good typing jobs.",
                    "You should be willing to re-edit a piece of content if needed."
                ]
            },
            "profession": "person doing typing job",
            "skillsNeeded": {
                "title": "",
                "skills": []
            },
            "benefits": [
                {
                    "name": "Earn while working at the comfort of your home.",
                    "img": Benefit1
                },
                {
                    "name": "Doesn't need any specific certification to be eligible for the job.",
                    "img": Benefit2
                },
                {
                    "name": "Good part-time job option for the students, working professionals as well as housewives.",
                    "img": Benefit3
                },
                {
                    "name": "Flexible working hours that you can choose as per your availability.",
                    "img": Benefit4
                }
            ],
            "checks": [
                "The turnaround time for completing the job should be less. Make sure that he can complete your typing task within the deadline.",
                "Experience in completing similar jobs successfully in the past and the reviews from his previous clients to know his performance and reliability",
                "Typing speed should be good enough like over 60 words per minute. This is needed especially when you have larger documents to be typed in less time.",
                "Check if he can provide you offers when you have bulk typing jobs to be done. In this way, you can hire him at a discounted price.",
                "Ask him if he can do a small test task like retyping 2-3 pages for free to check his accuracy before hiring.",
                "An assurance to keep the data secure, which has been shared with him for typing purposes.",
                "The person should be willing to provide the final document in the format as demanded by the hirer. Some common formats include Google Docs, excel sheets, PowerPoint, and PDF."
            ],
            "expected": [
                "Proofreading the document to avoid any minute errors.",
                "Revising the document which has been typed.",
                "Web research if demanded by the hirer.",
                "Retyping the data from the websites, PDFs, screenshots, scanned copies, or clear handwritten pages into a word document or excel sheets.",
                "Data entry into the excel sheets. This also includes typing complex mathematical expressions and chemical equations in the correct formatting."
            ],
            "faqs": [
                {
                    "id": 1,
                    "question": "What are the most important aspects of a person doing typing jobs?",
                    "answer": "A person doing typing job should have a good typing speed and must be able to accurately type the content in the final document with no errors.<br/><br/>With regular practice for 15-30 minutes every day, anyone can become good at typing. Even if your speed is less, in the beginning, you should not give up and the speed will easily increase. This will bring a lot of opportunities for you where your typing skills will be needed."
                },
                {
                    "id": 2,
                    "question": "How can accuracy be assured in typing jobs?",
                    "answer": "Accuracy depends on your practice level. Make sure to use the correct hand placement while learning the practicing skills until you are able to type swiftly without looking at the keyboard. This will help you better focus on the screen and correct any errors instantly when they appear.<br/><br/>It is essential to maintain a good posture and keep your hands in a comfortable position to ensure that you can type for longer hours without getting exhausted. The more you practice, the higher will be your speed and accuracy."
                },
                {
                    "id": 3,
                    "question": "In typing jobs, which is considered a good typing speed?",
                    "answer": "40 words per minute are considered to be a decent typing speed for standard work efficiency. But in the case of certain jobs like a personal assistant, the typing speed needs to be even higher, i.e at least 60 words per minute.<br/><br/>Generally, an average person has a typical typing rate of 38-40 words per minute but professionals have 65-75 words per minute typing speed."
                },
                {
                    "id": 4,
                    "question": "Which are the jobs that need typing skills?",
                    "answer": "There are 5 jobs that have typing as the primary requirement. These are data entry, freelance transcription jobs, assistant and secretary work, content creation, and copy editing jobs."
                },
                {
                    "id": 5,
                    "question": "How long does it take to learn typing?",
                    "answer": "You can easily learn typing in a few days but the speed will come gradually with practice. With your 10 fingers, you can type at a speed of 15 words per minute by learning for less than 10 hours in a day. You need more than 5 hours of practice.<br/><br/>Since it is not feasible to learn for 10 continuously, you can start with one lesson per day for a period of 10 days and 5 days for practicing."
                },
                {
                    "id": 6,
                    "question": "For a transcriptionist, what is the ideal typing speed expected?",
                    "answer": "60-70 words per minute are the ideal typing speed if you want to be a transcriptionist. This will help in transcribing audios in less time. As per industry standards, it takes 4 hours for transcribing an hour of audio"
                }
            ]
        },
        "music-audio-jobs": {
            "name": "Music & Audio Jobs",
            "to": "/browse-jobs/music-audio-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Music is a global connector that bridges all the communication gaps. There is a huge scope for candidates holding music degrees. They can use their skills for producing music or teaching others to play different musical instruments. It helps a person to use his creative skills for producing beautiful artwork. Just like other jobs, this too has good career options.",
            "importances": [],
            "duties": {
                "description": "",
                "data": []
            },
            "howItWorks": {
                "description": "",
                "details": [
                    {
                        "detail": "You can browse through the jobs related to music and audio and send an online application for the one which matches your skills."
                    },
                    {
                        "detail": "The application will be screened through various phases in the process of getting shortlisted."
                    },
                    {
                        "detail": "Once it is selected, you need to check all the instructions thoroughly and then start working. Upon completion of the assigned job, you will receive the payment."
                    }
                ]
            },
            "eligibility": {
                "eligibilities": [
                    'Inculcating interest in music starts right from childhood if you have a love for the same. Parents usually encourage the kids to take private lessons and join the school band during elementary education. Then gradually, years of practice makes them suitable to pursue their career in music.',
                    'Music lesson involves the composing and performing on the same that needs proper understanding and practice. A degree program caters to these basic needs for establishing a career in music. With it, taking part in the performances and events on special occasions boosts confidence.',
                    'The degree programs available start right from two-year associate programs offered by the degree schools by various community colleges to the Ph.D. programs conducted by various reputable institutes.'
                ]
            },
            "profession": "music and audio specialist",
            "skillsNeeded": {
                "title": "",
                "skills": [
                    "Should be able to read sheet music.",
                    "Understanding of the common terminologies.",
                    "Knowledge of the various ways of playing music and how it is conveyed in written form.",
                    "Capability of explaining different musical forms.",
                    "Songwriting skills.",
                    "Knowledge of various music composition styles.",
                    "Capability of composing and editing pieces created on MIDI equipment.",
                    "Being able to motivate the industry standards in the music business."
                ]
            },
            "benefits": [
                {
                    "name": "Some people love music and have a deep interest to learn it and pursue it as a part-time job. This gives a sense of satisfaction.",
                    "img": Benefit1
                },
                {
                    "name": "They can gradually learn the use of harmonies and melodies as tools.",
                    "img": Benefit2
                },
                {
                    "name": "They can be music teachers and explain the chord structures, major and minor keys as well as the variation of harmonics to the students in their online music classes.",
                    "img": Benefit3
                }
            ],
            "checks": [
                "Check his experience based on the work you are hiring him.",
                "Go through the client reviews to know his proficiency.",
                "Let him do a small test job first to be sure about his performance.",
                "He should be capable of writing music in standard, tablature, chords over lyrics, and other notations.",
                "If he is going to transcribe the music make sure he has experience in the same and does it with good accuracy.",
                "He should agree to stick to the deadline."
            ],
            "expected": [
                "Auto tuning",
                "Correction of the pitch",
                "Noise Reduction",
                "EQ or compression",
                "Aligning the audio, i.e Quantize",
                "Phase Correction",
                "Removal of noise",
                "Leveling"
            ],
            "faqs": [
                {
                    "id": 1,
                    "question": "Do music and audio specialists create sheet music?",
                    "answer": "Yes, there are certain music and audio specialists who can create sheet music from any video or audio recording. For this, you will have to send him the file or the music link that has to be transcribed accurately.<br/><br/>It is often done to learn the phrases of a musician by every note."
                },
                {
                    "id": 2,
                    "question": "What qualifications are needed to be an audio engineer?",
                    "answer": "A degree in the relevant subject in music technology is needed for this. It includes sound recording or audio engineering. In order to operate the complex equipment, high-level knowledge is needed."
                },
                {
                    "id": 3,
                    "question": "Can a person learn music and audio lessons online?",
                    "answer": "Yes, a person can get enrolled in online classes to gain the skills needed to establish a career in music and audio field. Then gradually he can start with internships and small projects to gain experience which can easily open up larger opportunities for him."
                },
                {
                    "id": 4,
                    "question": "What is the purpose of audio editing software? Is its knowledge mandatory to get a job related to music and audio?",
                    "answer": "As the name indicates it helps in editing and generating audio data like music, apply filters and effects to it, adjust the stereo channels, and others. Having knowledge of using the software is an added advantage and gives you a competitive edge over others."
                },
                {
                    "id": 5,
                    "question": "On being hired as a music producer, what tasks can be expected from you?",
                    "answer": "As a music producer, you will be responsible for checking the aspects of creating a song or an album that includes the choice of song, musicians, instruments, vocalists and the way of playing the instruments, way of singing the notes."
                },
                {
                    "id": 6,
                    "question": "Is it good to opt for a music career?",
                    "answer": "Yes but you need to have a lot of experience and skills to excel and get well paid in this. So it is better to pursue it as a part-time job."
                },
                {
                    "id": 7,
                    "question": "Which jobs need a person having skills related to music?",
                    "answer": "The jobs where all the knowledge of music and audio is needed are music producer, recording engineer, music publicist, composer, artist manager, music arranger and others."
                },
                {
                    "id": 8,
                    "question": "Who are perfect fit for music and audio jobs?",
                    "answer": "Anyone having a deep interest for learning music and having relevant skills are good fit for these jobs"
                },
                {
                    "id": 9,
                    "question": "Is learning music tough?",
                    "answer": "Music is simple but only when you understand its technicalities. With a good teacher, when you start learning the basics, you will feel that it is not at all tough."
                },
                {
                    "id": 10,
                    "question": "Can I get a job in the audio and music industry without a degree?",
                    "answer": "A degree doesn't matter but having a diploma, degree, or certification in the related field is an added advantage. The more experience you have, the better it is for getting a job."
                }
            ]
        },
        "programming-tech-jobs": {
            "name": "Programming Tech Jobs",
            "to": "/browse-jobs/programming-tech-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Engineering students generally opt for the work from home programming jobs which have application in various fields such as video games, business, and Operating system. This is a good way of adding some extra income for the students, homemakers who know coding, and the working professionals as well.",
            "importances": [],
            "duties": {
                "description": "",
                "data": [
                    "Development of optimized and efficient source code for the software applications.",
                    "Producing software tools and integrating them into a software system.",
                    "Maintaining and testing software to ensure that it is functioning properly."
                ]
            },
            "howItWorks": {
                "description": "",
                "details": [
                    {
                        "detail": "There are various programming jobs available on our platform which you can browse."
                    },
                    {
                        "detail": "Select the job which your skills match and send the online application for it."
                    },
                    {
                        "detail": "The application will be evaluated through multiple stages before being shortlisted."
                    },
                    {
                        "detail": "Once you are shortlisted for the job, go through all the instructions properly. Once the work is submitted, the payment will be initiated."
                    }
                ]
            },
            "eligibility": {
                "title": "",
                "eligibilities": [
                    "A full-time engineering degree (B.Tech or M.tech )in Computer Science, or BCA, MCA is needed with special proficiency in programming languages to be able to work as a programmer. This has a bachelor's as well as a master's degree. Besides this, diploma or certification courses can also be carried out for having an edge over other candidates."
                ]
            },
            "profession": "programming and tech expert",
            "skillsNeeded": {
                "title": "",
                "skills": [
                    "Back end development (Flask, bottle)",
                    "Automation",
                    "GUI",
                    "Data Structures",
                    "Simulation task",
                    "Web Bots",
                    "Web Scraping",
                    "Data Science",
                    "Scripts"
                ]
            },
            "benefits": [
                {
                    "name": "If you love coding and want to earn a handsome amount, you can start working from home by applying for programming jobs online.",
                    "img": Benefit1
                },
                {
                    "name": "It gives you a chance to polish your skills by letting you do what you like at your own pace. Thus, it is not stressful.",
                    "img": Benefit2
                },
                {
                    "name": "There is flexibility of work timings as you can commit to jobs depending on your free time.",
                    "img": Benefit3
                }
            ],
            "checks": [],
            "expected": [
                "Fixing the bugs",
                "Creating web pages with HTML/CSS/Javascript.",
                "Fixing the front end by changing the colors, font, and alignment, to completely revamp it.",
                "Enhance the responsiveness of a webpage.",
                "Make a website mobile friendly to prevent high bounce rates.",
                "Improvement of the UII/UX design.",
                "Creation of customized websites.",
                "API integration and displaying the data fetched from API on the web page."
            ],
            "faqs": [
                {
                    id: 1,
                    "question": "Do programming and tech experts have the skill to enhance the trading experience in the stock market?",
                    "answer": "Yes, they can help you have a better experience using online trading platforms. Let us consider the example of TadingView. The right candidate can help you code a strategy or indicator based on your specifications, add alerts to the current indicators, provide automation support to the indicators to use them with external trade execution systems, and enhance the indicator's UI."
                },
                {
                    "id": 2,
                    "question": "What are some examples of languages that candidates doing programming and tech jobs have knowledge about?",
                    "answer": "Javascript, JQuery, PHP, Python, HTML, CSS, Java, JSP, Database, ASP.Net are some of the examples. Some may also have knowledge about machine learning and data science."
                },
                {
                    "id": 3,
                    "question": "Which jobs need the coders?",
                    "answer": "There are a lot of different jobs which need coders. These are as follows:<br/><br/>1. Web developer.<br/>2. Computer programmer.<br/>3. Computer systems analyst.<br/>4. Database administrator.<br/>5. Software quality assurance (QA) engineer.<br/>6. Software application developer.<br/>7. Business intelligence analyst.<br/>8.Computer systems engineer."
                },
                {
                    "id": 4,
                    "question": "Is a degree mandatory to do a programming and tech job?",
                    "answer": "Those who do not have a relevant degree can also get programming and tech jobs by attending coding boot camps to learn the skills at affordable prices. This is the time-efficient way of getting started with this career."
                },
                {
                    "id": 5,
                    "question": "Do persons without experience get hired in programming and tech jobs?",
                    "answer": "Yes, if they have the relevant skillset and certifications to prove the same, then they get hired for the jobs but initially, they get paid lower, which gradually increases as they gain experience."
                },
                {
                    "id": 6,
                    "question": "Is it difficult to learn to code?",
                    "answer": "No, coding is not difficult but needs a lot of practice for beginners to gain efficiency. So they need to have a lot of patience and learn it patiently to excel."
                },
                {
                    "id": 7,
                    "question": "Why do people get frustrated while learning to program?",
                    "answer": "This is due to the lack of the right guidance. Some of the teachers teach how to write codes but fail to provide a practical experience, such as implementing it in producing the products. For example, a web developer has to create websites, and simply knowing just HTML tags won't work. Similarly, knowing object creation in C or Java is of no use for a mobile developer if he can't create an app using his knowledge."
                },
                {
                    "id": 8,
                    "question": "Can programming and tech jobs be done from home?",
                    "answer": "Yes because these coding jobs involve solitary work so you can easily become a freelance coder with the right skill set. There is no need for too much interaction with your peers in the office like in other jobs in this case."
                },
                {
                    "id": 9,
                    "question": "How much do programmers get paid in India?",
                    "answer": "The pay for programming and tech jobs starts from 4 LPA and increases with the experience and skillset."
                },
                {
                    "id": 10,
                    "question": "Can I learn coding on my own?",
                    "answer": "Yes, you can do it but the process will be difficult if you do not have a supportive background. With the right guidance, you can do it in less time and less effort."
                },
                {
                    "id": 11,
                    "question": "What are the highest paying programming and tech jobs?",
                    "answer": "System engineer, IT security specialist, Software engineer, Full stack developer, Cloud engineer, Data scientist, Mobile developer are some high-paying programming and tech jobs."
                },
                {
                    "id": 12,
                    "question": "How to enhance your coding skills?",
                    "answer": "You can take part in coding challenges on different websites to enhance your programming skills. Some of these include TopCoder, Coderbyte, Project Euler, HackerRank, CodeChef, Exercism.io, Codewars, and LeetCode."
                },
                {
                    "id": 13,
                    "question": "How can programming and tech jobs help people?",
                    "answer": "These jobs help people in fixing the issues in the website which the owners are not able to identify easily. They do it by thoroughly inspecting the code and using different technologies for a better user experience."
                }
            ]
        },
        "va-dataentry-jobs": {
            "name": "VA & Data Entry Jobs",
            "to": "/browse-jobs/va-dataentry-jobs",
            "aboutImages": [
                About1,
                About2
            ],
            "about": "Virtual assistant and data entry jobs are some of the popular jobs available for freelancers. Data entry, as the name indicates requires a candidate to enter data in the forms or excel sheets as per the client's requirements which can be done remotely. Virtual assistant jobs are remote administrative assistant jobs such as they might be asked to schedule appointments, make phone calls, plan for travel, make database entries, do social tasks or send emails. Let's see all aspects of this job.",
            "importances": [
                "VAs can set their working hours but sometimes they should be ready to complete the last-minute requirements of clients or work on the weekends. But they can take up jobs as per their availability and ensure smooth functioning.",
                "Sometimes a client may need a VA to perform some jobs specific to his skill set rather than the generic jobs. In such a scenario, it helps the candidate to work on his skills and gain a better experience. This can help in earn better in the future projects that he would be taking up.",
                "Virtual assistants are independent contractors so they have the privilege of working for more than one client based on his availability."
            ],
            "duties": {
                "description": "",
                "data": [
                    "Assisting the client with any type of administrative tasks that needs help.",
                    "Identifying and screening potential candidates.",
                    "Convincing potential clients to opt for you as their VA."
                ]
            },
            "howItWorks": {
                "description": "",
                "details": [
                    {
                        "detail": "Browse through the virtual assistant jobs available on our portal."
                    },
                    {
                        "detail": "Select the one which suits your skills and availability and send the online application for it."
                    },
                    {
                        "detail": "It will take about 24 hours for the evaluation of your online application through multiple phases."
                    },
                    {
                        "detail": "Once you are shortlisted, follow the instructions from the client to complete the job and get paid."
                    }
                ]
            },
            "eligibility": {
                "title": "Qualifications needed for a virtual assistant",
                "eligibilities": [
                    'A virtual assistant doesn\'t just need a 4-year degree through it will help them in bagging good clients. They need to take online training courses to learn the skills and how to do the job.',
                    'Besides this, there are companies that provide certifications to the VAs. This is an added advantage. So the candidate should try to get certification from community colleges or online educators.',
                    'A VA should have the skills of an administrative assistant or secretary. Also, he should have the skills for tracking the assignments of various clients. Communication skills are extremely important in the case of a VA as he would be working virtually and there has to be clarity in communicating information through phone or email.',
                    'A good VA has a range of computer skills and can proficiently use the latest software programs for completing their job proficiently.',
                    'A VA needs to be comfortable in doing multiple tasks at a time as requested by the client.'
                ]
            },
            "profession": "virtual assistant",
            "skillsNeeded": {
                "title": "",
                "skills": []
            },
            "benefits": [],
            "checks": [
                "Quick turnaround time.",
                "Responsive to messages, calls, and emails to ensure that no task is missed out.",
                "Regularly updating on the work progress to the concerned person.",
                "Availability in the particular hours as discussed while hiring. It varies as per the client's requirements.",
                "Check the track record of his previous work to know how satisfied his clients were."
            ],
            "expected": [
                "Converting PDF to MS Excel or Word",
                "CRM Data Entry",
                "Online or Offline Data Entry",
                "Formatting and Editing a document",
                "Sending out emails",
                "Creating an email list in excel or Google spreadsheet",
                "Verification of emails",
                "Conversion of an image to excel",
                "Getting contact details from the websites",
                "Web scraping",
                "Any type of copy-paste tasks",
                "Simple typing works in MS Excel or word",
                "Data Scraping",
                "Collection of data from LinkedIn",
                "Listing out products on an E-commerce site",
                "Typing content from Excel to word document",
                "Researching data related to properties.",
                "Conversion of JPEG to Excel or Word",
                "Typing the bank statement into an excel file.",
                "Researching data relating to real estate for name, email, contact, and similar details.",
                "Business Card Entry"
            ],
            "faqs": [
                {
                    "id": 1,
                    "question": "What does the virtual assistant job involve?",
                    "answer": "A virtual assistant is mainly responsible for providing administrative services to his clients. He works remotely from his office or home and schedules appointments, makes phone calls, travel arrangements, and manages emails."
                },
                {
                    "id": 2,
                    "question": "What are the skills needed to become a virtual assistant?",
                    "answer": "A person who intends to become a virtual assistant should have word processing skills, oral communication, writing, and computer skills. He must be self-motivated and disciplined, a quick thinker, an efficient decision-maker, and should be keen to learn new things whenever needed."
                },
                {
                    "id": 3,
                    "question": "Where can you apply for virtual assistant jobs?",
                    "answer": "You can apply for a virtual assistant in various freelancing platforms to securely work for your clients. It is extremely important that you do not opt for lucrative offers provided by some unknown firms as those are most probably traps to extract money from you."
                },
                {
                    "id": 4,
                    "question": "What programs are generally used by virtual assistants?",
                    "answer": "VAs often use social media platforms like Facebook, Instagram, Twitter, Hootsuite, Buffer, RecurPost, Tailwind, and others. They use Google Drive and Dropbox for storing data in the cloud. Apple Pages, Microsoft Word, Powerpoint, Google Docs, Google Sheets, are some of the productivity software used by them. They also use LeadPages for lead generation and other websites like WordPress."
                }
            ]
        }
    };
    static featuresProvided = {
        freelancers: [
            {
                title: 'Internship',
                content: 'Sign up for Free. Do internships and earn',
                to: '/internships',
                img: Feature1
            },
            {
                title: 'Post A Talent',
                content: 'Sign up for Free. Simply post what work you can.',
                to: '/post-talent',
                img: Feature2
            },
            {
                title: 'Find A Project',
                content: 'Sign up for Free. Simply find projects you look for',
                to: '/find-project',
                img: Feature3
            },
            {
                title: 'Job Board',
                content: 'Sign up for Free. Simply find projects you look for',
                to: '/job-board',
                img: Feature4
            }
        ],
        employers: [
            {
                title: 'Find A Talent',
                content: 'Sign up for Free. Simply find talents you look for.',
                to: '/hire-talent',
                img: Feature4
            },
            {
                title: 'Post A Project',
                content: 'Sign up for Free. Simply post what work you can.',
                to: '/post-project',
                img: Feature3
            }
        ]
    }

    static getJobs = () => {
        //change this api calling logic with actual API
        return this.jobs;
    }
    static getJob = (job) => {
        const talents = TalentsAPI.getTalents();
        const recent = {
            name: "Google Advertisement",
            jobImg: reviewWritingImg,
            talentsTitle: 'Recent Talents',
            talents: [...talents.slice(1)]
        };
        return { ...this.jobs[job], recent: recent };
    }
}
export default BrowseJobsAPI;